module.exports = __webpack_public_path__ + "static/media/home.391713cc.svg";